export default "__VITE_ASSET__BYIsV_on__"